import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-advanced-options',
  templateUrl: './advanced-options.component.html',
  styleUrls: ['./advanced-options.component.scss'],
})
export class AdvancedOptionsComponent {
  @Input()
  styleClass: string;
  advancedOptions = false;

  onTabOpen(event) {
    setTimeout(() => {
      const element: HTMLElement =
        event.originalEvent.originalTarget.parentElement.parentElement
          .parentElement;
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }, 300);
  }
}
